export const getters = {
  payss (state) {
    return state.payss
  },
  pays (state) {
    return state.pays
  },  
  pagination(state){
    return state.pagination
  }
}
